var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlueDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4997 2.5V3.33333H16.6663V5H15.833V15.8333C15.833 16.75 15.083 17.5 14.1663 17.5H5.83301C4.91634 17.5 4.16634 16.75 4.16634 15.8333V5H3.33301V3.33333H7.49967V2.5H12.4997ZM5.83301 15.8333H14.1663V5H5.83301V15.8333ZM7.49967 6.66667H9.16634V14.1667H7.49967V6.66667ZM12.4997 6.66667H10.833V14.1667H12.4997V6.66667Z",
    fill: "#5D49C7"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueDelete);
export default __webpack_public_path__ + "static/media/blue_delete.30b01fd9bbf1808a02a8ed305c77d670.svg";
export { ForwardRef as ReactComponent };